export const VIEW_TYPES = [
  {
    label: "전체",
    value: "ALL",
  },
  {
    label: "고객사",
    value: "NORMAL",
  },
  {
    label: "세무사",
    value: "TAX",
  },
  {
    label: "노무사",
    value: "LABOR",
  },
];
